import { render, staticRenderFns } from "./report-tizhi-ai.vue?vue&type=template&id=7f7cdc79&scoped=true"
import script from "./report-tizhi-ai.vue?vue&type=script&lang=ts"
export * from "./report-tizhi-ai.vue?vue&type=script&lang=ts"
import style0 from "./report-tizhi-ai.vue?vue&type=style&index=0&id=7f7cdc79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7cdc79",
  null
  
)

export default component.exports